module.exports = __webpack_public_path__ + "media/images/bestsecret-e22b095d49b3a0268c9474041a511722.png";